import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./fonts/fonts.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import MainPage from "./components/MainPage";
import Contact from "./components/Contact";
import Imprint from "./components/Imprint";
import Policy from "./components/Policy";
import IncomeClock from "./components/IncomeClock";
import IncomeClockPrivacy from "./components/IncomeClockPrivacy";
import LangRoute from "./components/LangRoute";
import "./styles_modern.css";
import "./css/boxicons.min.css";
import CookieConsent from "./components/CookieConsent";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            {/* German (default) */}
            <Route
              path="/"
              element={
                <LangRoute lang="de">
                  <MainPage lang="de" />
                </LangRoute>
              }
            />
            <Route
              path="/contact"
              element={
                <LangRoute lang="de">
                  <Contact lang="de" />
                </LangRoute>
              }
            />
            <Route path="/impressum" element={<Imprint />} />
            <Route path="/datenschutz" element={<Policy />} />
            <Route
              path="/projekte/income-clock"
              element={
                <LangRoute lang="de">
                  <IncomeClock lang="de" />
                </LangRoute>
              }
            />
            <Route
              path="/projekte/income-clock/datenschutz"
              element={
                <LangRoute lang="de">
                  <IncomeClockPrivacy lang="de" />
                </LangRoute>
              }
            />

            {/* English */}
            <Route
              path="/en"
              element={
                <LangRoute lang="en">
                  <MainPage lang="en" />
                </LangRoute>
              }
            />
            <Route
              path="/en/contact"
              element={
                <LangRoute lang="en">
                  <Contact lang="en" />
                </LangRoute>
              }
            />
            <Route
              path="/en/projekte/income-clock"
              element={
                <LangRoute lang="en">
                  <IncomeClock lang="en" />
                </LangRoute>
              }
            />
            <Route
              path="/en/projekte/income-clock/datenschutz"
              element={
                <LangRoute lang="en">
                  <IncomeClockPrivacy lang="en" />
                </LangRoute>
              }
            />
          </Routes>
          <Footer />
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
